import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { tap } from 'rxjs';
import { SideDrawerDirective } from '../../directives/sideDrawer.directive';
import { PageContainerService } from '../../services/page-container.service';

@Component({
    selector: 'st-mobile-right-menu',
    imports: [CommonModule, SideDrawerDirective],
    templateUrl: './mobile-right-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileRightMenuComponent {
  maxWidth = input.required<string>();
  isOpen = signal(false);

  expandMenuDrawer$ = this.pageContainerService.expandFilterDrawer$.pipe(
    tap(x => {
      this.isOpen.set(x);
    }),
  );

  constructor(readonly pageContainerService: PageContainerService) {}
}
